import { Button, Modal, TextInput } from "@mantine/core";
import type React from "react";
import type { ClientTrainingRequest } from "../../../types/portal";
import { formatCurrency } from "../../../utils/formatting";

interface CouponModalProps {
  opened: boolean;
  request: ClientTrainingRequest | null;
  couponCode: string;
  loading: boolean;
  onCouponChange: (code: string) => void;
  onCancel: () => void;
  onConfirm: () => void;
}

const CouponModal: React.FC<CouponModalProps> = ({
  opened,
  request,
  couponCode,
  loading,
  onCouponChange,
  onCancel,
  onConfirm,
}) => (
  <Modal
    opened={opened}
    onClose={onCancel}
    title=""
    withCloseButton={false}
    size="md"
    classNames={{
      content: "rounded-2xl overflow-hidden p-0",
      body: "p-0",
    }}
  >
    <div className="bg-primary text-primary-foreground py-4 sm:py-5 px-4 sm:px-6 text-center">
      <h3 className="m-0 text-lg sm:text-xl font-semibold">Enter Payment Details</h3>
    </div>
    <div className="p-4 sm:p-6">
      <div className="mb-5">
        <label className="block mb-2 font-semibold text-foreground text-[0.9rem]">
          Coupon Code (Optional):
        </label>
        <TextInput
          value={couponCode}
          onChange={(e) => onCouponChange(e.target.value.toUpperCase())}
          placeholder="Enter coupon code"
          maxLength={50}
        />
        <p className="text-[0.8rem] text-muted-foreground mt-1 italic">
          You can also enter a promo code during checkout on Stripe
        </p>
      </div>
      {request && (
        <div className="mt-5 p-4 bg-muted rounded-lg border border-border">
          <div className="flex justify-between items-center mb-2">
            <span className="text-[0.9rem] text-muted-foreground font-medium">Session Cost:</span>
            <span className="text-[0.9rem] text-foreground font-semibold">
              {formatCurrency(request.total_price || 0)}
            </span>
          </div>
          {couponCode && (
            <div className="flex justify-between items-center mb-2">
              <span className="text-[0.9rem] text-muted-foreground font-medium">
                Coupon Applied:
              </span>
              <span className="text-[0.9rem] text-foreground font-semibold">{couponCode}</span>
            </div>
          )}
        </div>
      )}
    </div>
    <div className="flex flex-wrap gap-3 justify-end px-4 sm:px-6 pb-4 sm:pb-6">
      <Button variant="default" className="min-w-[100px]" onClick={onCancel} disabled={loading}>
        Cancel
      </Button>
      <Button
        color="green"
        radius="md"
        className="min-w-[140px]"
        onClick={onConfirm}
        disabled={loading}
      >
        {loading ? "Processing..." : "Proceed to Payment"}
      </Button>
    </div>
  </Modal>
);

export default CouponModal;
